import axios from '@/axios/api.request'

export const save = (from) => axios.request({
  url: '/patent/overdue/save',
  data: from,
  method: 'post'
})